/**
 * isPopoutMode — true when this window is the netobs pop-out child
 * (`/?popout=1`). Cached on first call so 60Hz renderers don't re-parse.
 *
 * The hooks (useNetobsTraffic, useNetobsTick, useNetobsLatencyAggregate)
 * branch on this: in popout mode they read from popoutShimState
 * (populated by the BroadcastChannel listener) instead of from
 * `window.nm` / Colyseus messages directly.
 */
import { bootSearchParams } from '../../../../config/boot/bootUrl';

let cached: boolean | null = null;

export function isPopoutMode(): boolean {
  if (cached !== null) return cached;
  if (typeof window === 'undefined') {
    cached = false;
    return false;
  }
  try {
    const params = bootSearchParams();
    cached = params.get('popout') === '1';
  } catch {
    cached = false;
  }
  return cached;
}
